import { render } from "./saveType.vue?vue&type=template&id=0c4a02b2&scoped=true"
import script from "./saveType.vue?vue&type=script&lang=js"
export * from "./saveType.vue?vue&type=script&lang=js"

import "./saveType.vue?vue&type=style&index=0&id=0c4a02b2&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Latitude E5570\\Desktop\\MES DOSSIERS\\REAL_ESTATE_DEXTER\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c4a02b2"]])

export default __exports__